// extracted by mini-css-extract-plugin
module.exports = {"user_details_conv_archive_page":"styles_user_details_conv_archive_page__mYXBz","conversations_details":"styles_conversations_details__1BqF5","user_info":"styles_user_info__2Ekbt"};